// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const Ms365Icon = createSvgIcon(
  <svg width={316.23} height={316.23} fill="none" viewBox="0 0 73 73">
    <g clipPath="url(#ms365_svga)">
      <g clipPath="url(#ms365_svgb)">
        <path
          fill="url(#ms365_svgc)"
          d="M53.16 10.31A7.5 7.5 0 0 0 46 5.08h-2.47a7.5 7.5 0 0 0-7.38 6.12L32.5 30.92l1.1-3.64a7.5 7.5 0 0 1 7.18-5.33h11.48l6.58 2.3 3.5-2.29a7.5 7.5 0 0 1-7.15-5.24z"
        />
        <path
          fill="url(#ms365_svgd)"
          d="M20.62 62.8a7.5 7.5 0 0 0 7.16 5.28h4.86a7.5 7.5 0 0 0 7.5-7.4l.26-18.1-.99 3.28a7.5 7.5 0 0 1-7.18 5.34H20.75l-5.94-2.7-3.33 2.7a7.5 7.5 0 0 1 7.16 5.27z"
        />
        <path
          fill="url(#ms365_svge)"
          d="M45.5 5.08H19.25c-7.5 0-12 9.67-15 19.34C.7 35.88-3.95 51.21 9.5 51.21h11.43a7.5 7.5 0 0 0 7.2-5.4c1.98-6.73 5.42-18.44 8.13-27.36 1.38-4.54 2.53-8.44 4.3-10.87a6 6 0 0 1 4.94-2.5"
        />
        <path
          fill="url(#ms365_svgf)"
          d="M45.5 5.08H19.25c-7.5 0-12 9.67-15 19.34C.7 35.88-3.95 51.21 9.5 51.21h11.43a7.5 7.5 0 0 0 7.2-5.4c1.98-6.73 5.42-18.44 8.13-27.36 1.38-4.54 2.53-8.44 4.3-10.87a6 6 0 0 1 4.94-2.5"
        />
        <path
          fill="url(#ms365_svgg)"
          d="M27.5 68.08h26.24c7.5 0 12-9.67 15-19.34 3.56-11.46 8.21-26.78-5.25-26.78H52.06a7.5 7.5 0 0 0-7.2 5.39c-1.97 6.73-5.42 18.44-8.13 27.36-1.38 4.54-2.53 8.44-4.29 10.87a6 6 0 0 1-4.95 2.5"
        />
        <path
          fill="url(#ms365_svgh)"
          d="M27.5 68.08h26.24c7.5 0 12-9.67 15-19.34 3.56-11.46 8.21-26.78-5.25-26.78H52.06a7.5 7.5 0 0 0-7.2 5.39c-1.97 6.73-5.42 18.44-8.13 27.36-1.38 4.54-2.53 8.44-4.29 10.87a6 6 0 0 1-4.95 2.5"
        />
        <rect
          width={48.38}
          height={21.38}
          x={24.13}
          y={51.2}
          fill="#000"
          rx={3.64}
        />
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M27.07 55.29v13.03h2.4v-9.39l2.65 5.2h1.6l2.6-5.2v9.39h2.48V55.29h-2.78L33 61.33l-3-6.04zm18.01 13.2a5 5 0 0 1-3.35-1.03q-1.2-1.03-1.19-3.1h2.38q0 .99.56 1.54t1.6.55q.9 0 1.39-.46t.49-1.48q0-.95-.6-1.4-.59-.44-1.54-.44h-.78V60.7h.85q.85 0 1.35-.47.5-.45.5-1.22 0-.78-.45-1.15-.44-.37-1.23-.37-.86 0-1.33.49-.48.48-.48 1.3h-2.37q0-1.3.54-2.14.55-.84 1.5-1.26a5.58 5.58 0 0 1 4.15-.07q.94.36 1.5 1.1.57.72.57 1.88 0 1.17-.56 1.86-.55.69-1.5.97 1.05.2 1.72.97.69.75.69 2.1 0 1.83-1.2 2.82-1.17.96-3.2.96m7.8-.65q1.06.66 2.43.65 1.38 0 2.33-.54a3.6 3.6 0 0 0 1.45-1.49q.5-.96.5-2.2a4.4 4.4 0 0 0-.49-2.16 3.2 3.2 0 0 0-1.32-1.32 4 4 0 0 0-1.86-.46 3.9 3.9 0 0 0-2.8 1.15q.06-1.88.56-2.84.58-1.13 1.64-1.13.66 0 1.07.37.42.35.56 1.1h2.38a4 4 0 0 0-1.28-2.59q-1.02-.9-2.73-.9-1.38 0-2.45.7a4.6 4.6 0 0 0-1.69 2.16q-.6 1.45-.6 3.72 0 2.29.61 3.71.62 1.42 1.69 2.07m.25-4.51q.26-.25.57-.46a3 3 0 0 1 1.77-.53q.75 0 1.16.52.42.51.42 1.43 0 .94-.44 1.56-.42.62-1.3.62-.56 0-1.07-.36a2.6 2.6 0 0 1-.82-1.19 6 6 0 0 1-.3-1.59m9.78 4.74A5.8 5.8 0 0 0 67.4 68q1-.5 1.58-1.47a5 5 0 0 0 .58-2.47q0-1.48-.56-2.4a3.3 3.3 0 0 0-1.42-1.32 4 4 0 0 0-1.89-.42q-.77 0-1.34.25-.57.24-.85.57l.23-2.98h4.85v-2.12h-6.86l-.55 7.02h2.22q.26-.34.69-.57.4-.21 1.01-.22.85 0 1.39.52t.54 1.67q0 1.24-.51 1.83-.5.58-1.34.58a2 2 0 0 1-1.44-.5q-.56-.5-.56-1.37H60.7q0 1.3.59 2.18.6.85 1.62 1.29"
          clipRule="evenodd"
        />
      </g>
    </g>
    <defs>
      <radialGradient
        id="ms365_svgc"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="rotate(-130.29 36.92 1.78)scale(27.6431 26.1575)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.1} stopColor="#00AEFF" />
        <stop offset={0.77} stopColor="#2253CE" />
        <stop offset={1} stopColor="#0736C4" />
      </radialGradient>
      <radialGradient
        id="ms365_svgd"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="rotate(50.26 -46.66 41.86)scale(25.0142 24.5538)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#FFB657" />
        <stop offset={0.63} stopColor="#FF5F3D" />
        <stop offset={0.92} stopColor="#C02B3C" />
      </radialGradient>
      <radialGradient
        id="ms365_svgg"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="rotate(109.72 26.28 31.54)scale(61.4524 75.0539)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.07} stopColor="#8C48FF" />
        <stop offset={0.5} stopColor="#F2598A" />
        <stop offset={0.9} stopColor="#FFB152" />
      </radialGradient>
      <linearGradient
        id="ms365_svge"
        x1={17.68}
        x2={21.25}
        y1={10.67}
        y2={52.96}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.16} stopColor="#0D91E1" />
        <stop offset={0.49} stopColor="#52B471" />
        <stop offset={0.65} stopColor="#98BD42" />
        <stop offset={0.94} stopColor="#FFC800" />
      </linearGradient>
      <linearGradient
        id="ms365_svgf"
        x1={20.95}
        x2={22.9}
        y1={5.08}
        y2={51.21}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#3DCBFF" />
        <stop offset={0.25} stopColor="#0588F7" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="ms365_svgh"
        x1={66.92}
        x2={66.89}
        y1={19.14}
        y2={31.7}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.06} stopColor="#F8ADFA" />
        <stop offset={0.71} stopColor="#A86EDD" stopOpacity={0} />
      </linearGradient>
      <clipPath id="ms365_svga">
        <path fill="#fff" d="M.5.58h72v72H.5z" />
      </clipPath>
      <clipPath id="ms365_svgb">
        <path fill="#fff" d="M.5.58h72v72H.5z" />
      </clipPath>
    </defs>
  </svg>,
  "Ms365",
);
export default Ms365Icon;
